<span
  (click)="downloadPages($event, payload)"
  [innerHtml]="'app.page_download_generated' | translate: payload"
>
</span>
